import PropTypes from 'prop-types';
import React from 'react';

import Bag from '../../components/Bag';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import MobMenu from '../../components/MobMenu';
import SEO from '../../components/SEO';

const Layout = ({ children, title, metaDescription, metaKeywords }) => {
  return (
    <>
      <SEO title={title} description={metaDescription} keywords={metaKeywords} />
      <div className="min-w-screen min-h-screen flex flex-row bg-white relative overflow-hidden">
        <div className="w-full min-w-screen min-h-screen flex flex-col antialiased">
          <Header />
          <div className="container mx-auto">
          <main className="w-full flex flex-grow flex-col items-center py-20 sm:py-32 px-2 standalone:pt-32">{children}</main>
          <Footer />
          </div>
          <MobMenu />
        </div>
        <Bag />
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  metaDescription: PropTypes.string,
  metaKeywords: PropTypes.string,
};

export default Layout;
